import { render, staticRenderFns } from "./Cropper.vue?vue&type=template&id=0c8223ce&"
import script from "./Cropper.vue?vue&type=script&lang=js&"
export * from "./Cropper.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports